import { useRef } from "react";
import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";

export default function ArticleScroll() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const latestArticles = articles.slice(0, 8);

  const scroll = (direction: "left" | "right") => {
    if (scrollRef.current) {
      const amount = 320;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -amount : amount,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="py-16 md:py-20">
      <div className="px-6 md:px-14">
        <div className="flex items-center justify-between mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">最新瓜事</h2>
          <div className="flex items-center gap-2">
            <button
              onClick={() => scroll("left")}
              className="w-10 h-10 rounded-full bg-background-100 border border-background-200/70 flex items-center justify-center hover:bg-background-200/70 transition-colors cursor-pointer"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-s-line text-foreground-600"></i>
            </button>
            <button
              onClick={() => scroll("right")}
              className="w-10 h-10 rounded-full bg-background-100 border border-background-200/70 flex items-center justify-center hover:bg-background-200/70 transition-colors cursor-pointer"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-s-line text-foreground-600"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide"
          style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        >
          {latestArticles.map((article, idx) => (
            <ArticleCard
              key={article.id}
              slug={article.slug}
              title={article.title}
              imageUrl={article.imageUrl}
              tag={article.tag}
              date={article.date}
              views={article.views}
              isHot={article.isHot}
              isFirst={idx === 0}
            />
          ))}
        </div>
      </div>
    </section>
  );
}